var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdling({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFBB54",
    viewBox: "0 0 22 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.423 8.716V9.788H18.995V9.008L17.381 7.008H16.215V4.808H12.491V3.728H14.291V0H6.356V3.729H8.156V4.8H5.627V6.6H2.449V9.206H1.271V7.762H0V11.927H1.271V10.483H2.449V13.546H6.1L7.7 15.309H19V14.279H20.428V15.3H21.699V8.72L20.423 8.716ZM9.432 3.729H11.22V4.8H9.432V3.729Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdling);
export default __webpack_public_path__ + "static/media/idling.6e5eeb0fb3e1ef90e20b0c027d858dbf.svg";
export { ForwardRef as ReactComponent };